import PropTypes from 'prop-types';
import IconedLink from '@/components/common/iconedLinks/IconedLink';
import { URLS } from '@/constants/urls';

const ModifyIconedLink = ({ id, onEdit, textIsEdit = false, rbf }) => (
  <IconedLink
    id={id}
    text={`btn.${textIsEdit ? 'edit' : 'modify'}`}
    icon={URLS.EDIT_BLACK}
    onClicked={onEdit}
    rbf={rbf}
  />
);

ModifyIconedLink.propTypes = {
  id: PropTypes.string,
  onEdit: PropTypes.func.isRequired,
  textIsEdit: PropTypes.bool,
  rbf: PropTypes.string
};

export default ModifyIconedLink;
